export const quickSortOn =
  <T>(property: keyof T) =>
  (a: T, b: T) => {
    const $1 = a[property],
      $2 = b[property]

    if (typeof $1 !== 'number' || typeof $2 !== 'number') {
      throw new Error('Sorting is only supported for numbers')
    }

    return $1 - $2
  }
